
<!--page starts-->
<section class="page-wrapper">
    <div class="player-staff-section margin-top-152 cf">
    	<div class="player-staff-section-inner margin-top-50 cf">
	    	<div class="container">
                <div class="privacy-detail">
                    <div [innerHTML]="settingList?.data?.cookie"></div>
                </div>
	    	</div>
	    </div>
	</div>
</section><!-- page ends-->